import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Progress } from "@/components/ui/progress";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";

const projects: Array<{ id: number; name: string; subsidiary: string; budget: string; status: 'en_cours'|'retard'|'planification'; progress: number; manager: string; managerName: string }> = [
    {
        id: 1,
        name: "Expansion Usine Lyon",
        subsidiary: "Socolait",
        budget: "3.2M€",
        status: "en_cours",
        progress: 65,
        manager: "LC",
        managerName: "Laurent Caron"
    },
    {
        id: 2,
        name: "Migration ERP",
        subsidiary: "Division IT",
        budget: "1.8M€",
        status: "retard",
        progress: 42,
        manager: "PD",
        managerName: "Philippe Durand"
    },
    {
        id: 3,
        name: "Optimisation Énergétique",
        subsidiary: "Développement Durable",
        budget: "950K€",
        status: "en_cours",
        progress: 78,
        manager: "ML",
        managerName: "Marie Lefèvre"
    },
    {
        id: 4,
        name: "Flotte Véhicules Électriques",
        subsidiary: "Logistique",
        budget: "1.4M€",
        status: "planification",
        progress: 5,
        manager: "TB",
        managerName: "Thomas Bertrand"
    }
];

const statusColors: Record<string, string> = {
    "en_cours": "bg-green-100 text-green-800",
    "retard": "bg-red-100 text-red-800",
    "planification": "bg-blue-100 text-blue-800"
};

const statusLabels: Record<string, string> = {
    "en_cours": "En cours",
    "retard": "Retard",
    "planification": "Planification"
};

export default function ActiveProjectsTable() {
    return (
        <Card className="border-0 shadow-lg">
            <CardHeader>
                <CardTitle className="text-lg font-bold text-gray-900">
                    Projets Actifs
                </CardTitle>
            </CardHeader>
            <CardContent>
                <Table>
                    <TableHeader>
                        <TableRow>
                            <TableHead>Projet</TableHead>
                            <TableHead>Budget</TableHead>
                            <TableHead>Statut</TableHead>
                            <TableHead>Progression</TableHead>
                            <TableHead>Responsable</TableHead>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                        {projects.map((project) => (
                            <TableRow key={project.id} className="hover:bg-gray-50">
                                <TableCell>
                                    <div>
                                        <p className="font-medium text-gray-900">{project.name}</p>
                                        <p className="text-sm text-gray-500">{project.subsidiary}</p>
                                    </div>
                                </TableCell>
                                <TableCell className="font-medium">{project.budget}</TableCell>
                                <TableCell>
                                    <Badge className={statusColors[project.status]}>
                                        {statusLabels[project.status]}
                                    </Badge>
                                </TableCell>
                                <TableCell>
                                    <div className="flex items-center gap-3">
                                        <Progress value={project.progress} className="w-16" />
                                        <span className="text-sm font-medium">{project.progress}%</span>
                                    </div>
                                </TableCell>
                                <TableCell>
                                    <div className="flex items-center gap-2">
                                        <Avatar className="w-8 h-8">
                                            <AvatarFallback className="bg-teal-100 text-teal-700 text-xs">
                                                {project.manager}
                                            </AvatarFallback>
                                        </Avatar>
                                        <span className="text-sm">{project.managerName}</span>
                                    </div>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </CardContent>
        </Card>
    );
}
